var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgWhatsapp = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    d: "M16.5892 13.9229L16.5817 13.9854C14.7492 13.072 14.5575 12.9504 14.3208 13.3054C14.1567 13.5512 13.6783 14.1087 13.5342 14.2737C13.3883 14.4362 13.2433 14.4487 12.9958 14.3362C12.7458 14.2112 11.9433 13.9487 10.9933 13.0987C10.2533 12.4362 9.75667 11.6237 9.61001 11.3737C9.36584 10.952 9.87667 10.892 10.3417 10.012C10.425 9.83703 10.3825 9.69953 10.3208 9.57537C10.2583 9.45037 9.76084 8.22536 9.55251 7.73703C9.35251 7.25036 9.14667 7.31203 8.99251 7.31203C8.51251 7.27037 8.16167 7.27703 7.85251 7.5987C6.50751 9.07703 6.84667 10.602 7.99751 12.2237C10.2592 15.1837 11.4642 15.7287 13.6675 16.4854C14.2625 16.6745 14.805 16.6479 15.2342 16.5862C15.7125 16.5104 16.7067 15.9854 16.9142 15.3979C17.1267 14.8104 17.1267 14.3229 17.0642 14.2104C17.0025 14.0979 16.8392 14.0354 16.5892 13.9229Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    d: "M19.1 4.87453C12.6925 -1.31964 2.08833 3.17286 2.08417 11.9112C2.08417 13.6579 2.54167 15.3612 3.41333 16.8654L2 22.0004L7.27917 20.6237C13.8667 24.182 21.9967 19.457 22 11.9162C22 9.26953 20.9667 6.77869 19.0875 4.90703L19.1 4.87453ZM20.335 11.8887C20.33 18.2495 13.3475 22.222 7.825 18.9754L7.525 18.797L4.4 19.6095L5.2375 16.572L5.03833 16.2595C1.60167 10.7887 5.55 3.63869 12.06 3.63869C14.2717 3.63869 16.3475 4.50119 17.9108 6.06369C19.4733 7.61286 20.335 9.68869 20.335 11.8887Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgWhatsapp;